// Services and injection tokens
export {
  DynamicVariableService,
  Category,
  DynamicField,
  ImageUploadService,
  BuilderService,
  PreviewResult,
  SendPreviewService,
  PromptBuilder,
  DefaultPromptBuilder,
  ContentBuilderDependencies,
  CONTENT_BUILDER_DEPENDENCIES,
  SettingType,
  Contact,
  ContactProvider,
  ContactSearchResult,
  SendPreviewDialogData,
} from './src/interface';

// Block interfaces and default values
export {
  BlockType,
  ContentBlockInterfaces,
  ImageBlock,
  blankImageBlock,
  RichTextBlock,
  blankRichTextBlock,
  HeadingBlock,
  blankHeadingBlock,
  ButtonBlock,
  blankButtonBlock,
  ImageAndTextBlock,
  ImageAndTextItem,
  blankImageAndTextBlock,
  SimpleTableBlock,
  SimpleTableRow,
  SimpleTableRowWithId,
  blankSimpleTableBlock,
  ContactCard,
  AdditionalRow,
  blankContactCardBlock,
  DividerBlock,
  blankDividerBlock,
  SpacerBlock,
  blankSpacerBlock,
  HtmlBlock,
  blankHtmlBlock,
} from './src/interface';

// Content structure
export {
  ContentBlockItem,
  blankContentBlockItem,
  ContentSetup,
  ContentData,
  BlockNamesAndIconsType,
  defaultBlockChoices,
  DEFAULT_CONTENT_DATA,
  TopLogoSettings,
  ColorSettings,
  FooterSettings,
  PageSettings,
} from './src/interface';

// Block components
export { ButtonBlockComponent } from './src/blocks/button-block/button-block.component';
export { DividerBlockComponent } from './src/blocks/divider-block/divider-block.component';
export { SpacerBlockComponent } from './src/blocks/spacer-block/spacer-block.component';
export { SimpleTableBlockComponent } from './src/blocks/simple-table-block/simple-table-block.component';
export { HtmlBlockComponent } from './src/blocks/html-block/html-block.component';
export { HeadingBlockComponent } from './src/blocks/heading-block/heading-block.component';
export { RichTextBlockComponent } from './src/blocks/rich-text-block/rich-text-block.component';
export { ImageBlockComponent } from './src/blocks/image-block/image-block.component';
export { ImageAndTextBlockComponent } from './src/blocks/image-and-text-block/image-and-text-block.component';
export { ContactCardComponent } from './src/blocks/contact-card/contact-card.component';

// Main components
export { BuilderComponent } from './src/builder/builder.component';
export { BlockListComponent } from './src/block-list/block-list.component';
export { PreviewComponent } from './src/preview/preview.component';
export { PageComponent } from './src/page/page.component';

export { SendPreviewDialogComponent } from './src/send-preview-dialog/send-preview-dialog.component';
export { InboxPreviewComponent } from './src/inbox-preview/inbox-preview.component';
